<template>
  <list-item class="group-exercise-item" @click="() => $emit('click')">
    <template slot="left" v-if="hasImage">
      <div
        :class="[
          { '--condensed': condensed },
          'group-exercise-item__image-wrapper'
        ]"
      >
        <img
          :src="exerciseImage"
          :alt="item.exercise.title"
          class="group-exercise-item__image"
        />
      </div>
    </template>

    <div>
      <span class="v-list-item__title">
        <div
          :class="[{ '--no-wrap': condensed }, 'group-exercise-item__title']"
        >
          {{ item.exercise.title }}
        </div>
      </span>
      <div>
        <group-item-details
          class="group-exercise-item__details font-weight-bold"
          :item="item"
        />
      </div>
    </div>

    <template slot="right">
      <template v-if="canCapture">
        <form-capture-button
          v-if="item.uid"
          class="ml-1"
          :capture-uid="item.uid"
          @capture="startIndex => $emit('captureClicked', startIndex)"
        />
      </template>
    </template>
    <template slot="row" v-if="item.notes && !condensed">
      <span class="v-list-item__subtitle">
        {{ item.notes }}
      </span>
    </template>
  </list-item>
</template>

<script>
import { isPresent } from "@/lib/utils"
import { parseWorkoutUnits } from "@/lib/workout-utils"

import ListItem from "@/components/ListItem"
import GroupItemDetails from "@/components/workout/GroupItemDetails"

export default {
  components: {
    ListItem,
    GroupItemDetails,
    FormCaptureButton: () => import("@/components/workout/FormCaptureButton")
  },

  props: {
    item: { type: Object, required: true },
    condensed: { type: Boolean, default: false },
    canCapture: { type: Boolean, default: false }
  },

  computed: {
    hasImage() {
      return isPresent(this.exerciseImage)
    },

    exerciseImage() {
      if (!this.item.exercise) {
        return null
      }

      const { banner, video } = this.item.exercise

      return isPresent(banner)
        ? banner.image.url
        : isPresent(video) && video.thumbnail_url
        ? video.thumbnail_url
        : null
    }
  },

  methods: {
    parseWorkoutUnits
  }
}
</script>
<style lang="scss">
@import "@/assets/styles/variables";

.group-exercise-item__image-wrapper {
  position: relative;
  display: inline-block;
  height: 3.75rem;
  width: 5rem;
  margin-right: $size--3;

  &.--condensed {
    height: 3rem;
    width: 4rem;
  }
}

.group-exercise-item__image {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: var(--border-radius);
}

.group-exercise-item__details {
  margin-top: $size--1;
  font-weight: $font-weight--semi-bold;
  font-size: $font-size--small;
}

.group-exercise-item__title {
  &.--no-wrap {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
